import type { FaireProductEntity } from "../../entity_types/product";

export const p_hdnavxzpr4: FaireProductEntity = {
  token: "p_hdnavxzpr4",
  type: "product",
  name: "Bookstore Thank You Greeting Card",
  brandToken: "b_dfu92850",
  brandName: "Pippi Post",
  imageUrl:
    "https://cdn.faire.com/fastly/51ceefab315d600c9d8df9b1985100970d3120747e0b3b49260a0a898af3dd23.jpeg",
  galleryImageUrls: [],
  priceDollars: 3,
  description:
    "Express your heartfelt gratitude with the Bookstore Thank You Greeting Card! Perfect for showing appreciation to your favorite bookstore staff, fellow book lovers, or anyone who’s helped you find your next great read, this charming card combines literary elegance with a warm message of thanks. Whether it’s for a special gesture, exceptional service, or just because, this card is the ideal way to say “thank you” to those who share your love for books.\n\n• Size: A2, 4.25 x 5.5\"\n• Interior: Blank\n• Foil: Gold\n• Envelope color may vary\n• Sentiment: You're The Best Thank You",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:21.214Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
